const TaskStatus = {

    // FIELDS
    "task_status": "Task Status",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Task Status",
    "filter_title": "Task Status Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Task Status Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default TaskStatus;

